<ng-container [ngSwitch]="item!.type">
  <a
    class="nav-link"
    [ngClass]="item!.class ? item!.class : ''"
    [href]="item!.navigateTo"
    *ngSwitchCase="itemType.Link"
    >{{ item?.name | msg | async }}</a
  >

  <a
    *ngSwitchCase="itemType.Email"
    class="nav-link"
    [ngClass]="item!.class ? item!.class : ''"
    [href]="'mailto:' + item!.navigateTo"
  >
    {{ item?.name | msg | async }}
  </a>

  <a
    *ngSwitchCase="itemType.Phone"
    class="nav-link"
    [ngClass]="item!.class ? item!.class : ''"
    [href]="'tel:' + item!.navigateTo"
  >
    {{ item?.name | msg | async }}
  </a>

  <button
    *ngSwitchCase="itemType.Button"
    [class]="item!.class"
    (click)="item?.onClick()"
  >
    {{ item!.name | msg | async }}
  </button>

  <!-- <button
    *ngSwitchCase="itemType.Profile"
    [class]="item!.class"
    (click)="navigate(item?.navigateTo!)"
  >
    <svg-icon
      src="../../../assets/images/icons/person.svg"
      [svgStyle]="{ 'width.px': 42, 'height.px': 42 }"
    ></svg-icon>
  </button> -->

  <span class="nav-link" *ngSwitchDefault>{{ item?.name | msg | async }}</span>
</ng-container>
